import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createShareURLIntent(): WebViewIntent {
  return createIntent('SHARE_URL')
}
